module.exports = __webpack_public_path__ + "static/nijisanjibot-e6a37bd5c00b56a9292fff608ba8514d.png";